import { useState } from 'react';
import { getCsdConsent, saveCsdConsent } from '../lib/privacyConsent';

export default function PrivacyConsentBanner() {
  const [visible, setVisible] = useState(() => !getCsdConsent().updatedAt);
  if (!visible) return null;
  const decide = (accepted: boolean) => {
    saveCsdConsent(accepted, accepted);
    setVisible(false);
  };
  return (
    <aside className="fixed bottom-4 left-4 right-4 z-[100] mx-auto max-w-4xl rounded-2xl border border-white/15 bg-slate-950/95 p-5 text-white shadow-2xl backdrop-blur-xl">
      <div className="flex flex-col gap-4 md:flex-row md:items-center">
        <span className="shrink-0 text-2xl text-red-500" aria-hidden="true">◈</span>
        <div className="flex-1">
          <strong>Votre confidentialité compte</strong>
          <p className="mt-1 text-sm text-slate-300">Les mesures d’audience et outils marketing restent désactivés sans votre accord.</p>
        </div>
        <div className="flex gap-2">
          <button className="rounded-lg border border-white/20 px-4 py-2 font-semibold" onClick={() => decide(false)}>Refuser</button>
          <button className="rounded-lg bg-red-600 px-4 py-2 font-bold" onClick={() => decide(true)}>Accepter</button>
        </div>
      </div>
    </aside>
  );
}
